import { sections as HealthSurveillanceQuestionnaireSections } from "@teamprevent/common/healthSurveillance/questionnaire";

import { values } from "lodash";

import { MedicalCategory } from "@teamprevent/common/healthSurveillance/models";

import { sections as HealthSurveillanceConsultationSections } from "../healthSurveillance/consultation";

const QuestionnaireSectionOptions = values(HealthSurveillanceQuestionnaireSections).map(section => ({
    value: section.id,
    text: section.label ?? section.title
}));
const ConsultationSectionOptions = values(HealthSurveillanceConsultationSections).map(section => ({
    value: section.id,
    text: section.label ?? section.title
}));

export interface CustomMedicalTypeListModel {
    readonly id: string;
    readonly name: string;
    readonly category: MedicalCategory;
    readonly questionnaireSectionIds: typeof HealthSurveillanceQuestionnaireSections[keyof typeof HealthSurveillanceQuestionnaireSections]["id"][];
    readonly consultationSectionIds: typeof HealthSurveillanceConsultationSections[keyof typeof HealthSurveillanceConsultationSections]["id"][];
}

// Leaving both models here to make future deviations easier
export interface CustomMedicalTypeDetailModel extends CustomMedicalTypeListModel {
}

export interface CustomMedicalTypeOptions {
    text: string;
    value: string;
}

export type CustomMedicalType = CustomMedicalTypeListModel | CustomMedicalTypeDetailModel;

export {
    QuestionnaireSectionOptions,
    ConsultationSectionOptions,
};
